import { Component, computed, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { INews } from '@core/interfaces/news.interface';
import { TranslateModule } from '@ngx-translate/core';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TextClampTooltipDirective } from '@shared/directives/text-clamp-tooltip.directive';
import { TimeagoModule } from 'ngx-timeago';
import { NotificationsButtonService } from '../notifications-button.service';

@Component({
  imports: [
    TimeagoModule,
    TranslateModule,
    IconBadgeComponent,
    MatButtonModule,
    MatTooltipModule,
    TextClampTooltipDirective,
    IconComponent,
  ],
  selector: 'app-notifications-panel',
  styleUrl: './notifications-panel.component.scss',
  templateUrl: './notifications-panel.component.html',
})
export class NotificationsPanelComponent {
  public readonly news = input.required<INews[]>();
  public readonly isOpen = input.required<boolean>();

  public readonly closePanel = output<void>();
  // Opening a specific item is decided by the parent, which is the single owner of "is a news
  // dialog currently open" - it can then enforce that at most one is ever open at a time.
  public readonly newsClick = output<INews>();

  public readonly readNewsIds = computed<Set<string>>(() => {
    // Recompute whenever the panel opens/closes or the news list changes, since both are the
    // moments the parent writes new read-ids to storage.
    this.isOpen();
    this.news();

    return new Set(this.notificationsButtonService.getReadNewsIds());
  });

  private readonly notificationsButtonService = inject(NotificationsButtonService);

  public onClose(): void {
    this.closePanel.emit();
  }

  public onNewsClick(newsItem: INews): void {
    this.newsClick.emit(newsItem);
  }

  public isUnread(newsItem: INews): boolean {
    return !!newsItem.id && !this.readNewsIds().has(newsItem.id);
  }
}
